import {Component, OnInit} from '@angular/core';
import {TiendaServices} from '../../CoreModule/services/tienda.services';
import {EmpleadoServices} from '../../CoreModule/services/empleado.services';
import {ActivatedRoute} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {EmpleadoModel} from '../../CoreModule/models/empleado.model';
import {TiendaModel} from '../../CoreModule/models/tienda.model';
import {SemanaServices} from '../services/semana.services';
import {SemanaModel} from '../models/semana.model';
import {EmpleadoSemanaModel} from '../models/empleado.semana.model';

@Component({
  selector:"detalle-empleado",
  templateUrl:"../templates/tiendas/detalle.empleado.template.html"
})
export class DetalleEmpleadoComponent implements OnInit{

  public empleado:EmpleadoModel;
  public tienda:TiendaModel;
  public semana:SemanaModel;
  public em:EmpleadoSemanaModel;

  constructor( private ts:TiendaServices, private es:EmpleadoServices, private ss:SemanaServices, private activeRouter: ActivatedRoute, private spinner: NgxSpinnerService){

  }

  ngOnInit(): void {
    let idEmple = this.activeRouter.snapshot.params.id;

    let ano, sem, tienda, semana = undefined;

    if (this.activeRouter.snapshot.queryParams.ano)
      ano = +this.activeRouter.snapshot.queryParams.ano;
    if (this.activeRouter.snapshot.queryParams.semana)
      sem = +this.activeRouter.snapshot.queryParams.semana;

    if (this.activeRouter.snapshot.queryParams.tienda)
      tienda = +this.activeRouter.snapshot.queryParams.tienda;

    if (this.activeRouter.snapshot.queryParams.semana)
      tienda = +this.activeRouter.snapshot.queryParams.semana;

    //
    //
    // obtener empleado, semana y tienda

    this.es.devolverDetalleEmpleado(ano, sem, tienda, idEmple).subscribe(d=>{
      console.log(d);
    })


    // this.es.devolverSemanaEmpleado(idEmple,sem).subscribe(d=>{
    //   console.log(d);
    // });
    //
    // this.es.devolverEmpleado(idEmple).subscribe(d=>{
    //   this.empleado = EmpleadoModel.CREAREMPLEADO(d.data.devolverEmpleado);
    // });
    //
    // this.es.devolverSemanaTienda(idEmple, sem);





  }

  // calcular indicadores, el calculo de indicadores debe ir en un servicio

  // mostrar detalle de la semana

  // mostrar plan de accion

  // devolver a la semana

}
